export default "__VITE_ASSET__a11926b2__"